import React, { useContext, useMemo, useState, useEffect } from "react";
import { MyContext } from "../Context/MyContext";
import "./FilterModal.css";

export default function FilterModal({ type, close }) {
  const {brands,
            model,
            fuel_type,
            transmission,
            seats,
            body_type,
            car_color,
            featuers,
            cars} = useContext(MyContext);
  const { filters, toggleFilter, applyRange, clearFilters, setCertifiedOnly, certifiedCarCount, car_trust } = useContext(MyContext);

  // Temp state for ranges (editable before GO)
  const [tempRange, setTempRange] = useState({ ...filters });

  useEffect(() => {
    setTempRange({ ...filters });
  }, [filters]);

  // Filter model based on selected brands (inside useMemo)
  const filteredModels = useMemo(() => {
    const selectedBrands = filters.brand_ids || [];
    if (selectedBrands.length === 0) return model;
    return model.filter(model => selectedBrands.includes(model.brand_id));
  }, [filters.brand_ids,model]);

  const getCount = (key, value) => {
  return cars.filter(car => {
    for (const filterKey in filters) {
      if (filterKey === key + "s" || filterKey === key + "_ids") continue;

      const selected = filters[filterKey];

      if (Array.isArray(selected) && selected.length > 0) {
        const carKey = filterKey.replace("_ids", "_id");

        // ✅ if car value is array (featuers)
        if (Array.isArray(car[filterKey])) {
          if (!selected.some(v => car[filterKey].includes(v))) return false;
        } else {
          if (!selected.includes(car[carKey])) return false;
        }
      }
    }

    // ✅ FINAL MATCH
    if (Array.isArray(car[key + "s"])) {
      return car[key + "s"].includes(value);
    }

    return car[key] === value;
  }).length;
};


  const renderItems = (list, key, imageKey = null) => (
    <div className="modal-grid">
      {list.map(item => (
        <div
          key={item.id}
          className={`modal-item ${filters[key]?.includes(item.id) ? "active" : ""}`}
          onClick={() => toggleFilter(key, item.id)}
        >
          {imageKey && <img src={item[imageKey]} alt={item.name} />}
          <span>{item.name}</span>
          <small>({getCount(key.replace("_ids", "_id"), item.id)})</small>
        </div>
      ))}
    </div>
  );

  const renderRange = (label, minKey, maxKey, minLimit, maxLimit) => {
    const isDisabled =
      tempRange[minKey] === filters[minKey] && tempRange[maxKey] === filters[maxKey];

    const handleMinChange = e => {
      const value = e.target.value === "" ? "" : Number(e.target.value);
      setTempRange(prev => ({ ...prev, [minKey]: value }));
    };

    const handleMaxChange = e => {
      const value = e.target.value === "" ? "" : Number(e.target.value);
      setTempRange(prev => ({ ...prev, [maxKey]: value }));
    };

    return (
      <div className="range-box">
        <h4>{label}</h4>
        <div className="range-inputs">
          <input
            type="number"
            value={tempRange[minKey]}
            min={minLimit}
            max={tempRange[maxKey] === "" ? maxLimit : tempRange[maxKey]}
            onChange={handleMinChange}
          />
          <span>to</span>
          <input
            type="number"
            value={tempRange[maxKey]}
            min={tempRange[minKey] === "" ? minLimit : tempRange[minKey]}
            max={maxLimit}
            onChange={handleMaxChange}
          />
          <button
            className="range-go-btn"
            disabled={
              isDisabled || tempRange[minKey] === "" || tempRange[maxKey] === ""
            }
            onClick={() =>
              applyRange({
                [minKey]: Number(tempRange[minKey]),
                [maxKey]: Number(tempRange[maxKey])
              })
            }
          >
            GO
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="filter-modal" onClick={close}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Filter</h3>
          <button onClick={close}>✕</button>
        </div>

        {(type === "all" || type === "certified") && (
          <div className="modal-certified-block">
            <button
              type="button"
              className={`modal-certified-toggle ${filters.certified_only ? "active" : ""}`}
              onClick={() => setCertifiedOnly(!filters.certified_only)}
            >
              {car_trust?.badges?.certified || "Certified"} cars only ({certifiedCarCount})
            </button>
          </div>
        )}

        {/* Category filters */}
        {(type === "brand" || type === "all") && renderItems(brands, "brand_ids", "image")}
        {(type === "model" || type === "all") && (
          <div className="scrollable-model">{renderItems(filteredModels, "model_ids")}</div>
        )}
        {(type === "fuel" || type === "all") && renderItems(fuel_type, "fuel_type_ids")}
        {(type === "color" || type === "all") && renderItems(car_color, "color_ids")}
        {(type === "feature" || type === "all") && renderItems(featuers, "feature_ids")}
        {(type === "all") && renderItems(body_type, "body_type_ids")}
        {(type === "all") && renderItems(transmission, "transmission_ids")}
        {(type === "all") && renderItems(seats, "seats_ids")}

        {/* Range filters */}
        {type === "all" && (
          <>
            {renderRange("Model Year", "year_min", "year_max", 2010, 2025)}
            {renderRange("Tire Wear %", "tire_min", "tire_max", 0, 100)}
            {renderRange("Price", "price_min", "price_max", 0, 10000000)}
            {renderRange("Kilometer Driven", "km_min", "km_max", 0, 1000000)}
          </>
        )}

        {/* Clear filters */}
        <button className="clear-btn" onClick={clearFilters}>
          Clear Filters
        </button>
      </div>
    </div>
  );
}
